var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Movies of the area")]),_c('v-card-text',_vm._l((_vm.areamovies),function(movie,index){return _c('span',{key:index},[_c('Movie',{attrs:{"movie":movie}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }